var map = {
	"./22/TONwallet.png": 15941,
	"./22/ag.png": 14631,
	"./22/airdorp-item1-bg.png": 31712,
	"./22/airdorp-item2-bg.png": 46547,
	"./22/btn-copy.png": 65134,
	"./22/car-img.png": 83175,
	"./22/car_z.png": 46039,
	"./22/icon-airdrop.png": 56877,
	"./22/icon-boost.png": 98850,
	"./22/icon-coin.png": 13422,
	"./22/icon-frends.png": 6099,
	"./22/icon-home.png": 98392,
	"./22/icon-learderboard.png": 30754,
	"./22/it.png": 46945,
	"./22/page2_bg2.png": 93364,
	"./22/rank-1.png": 66768,
	"./22/rank-2.png": 39882,
	"./22/rank-3.png": 23178,
	"./22/ton-icon-big.png": 27372,
	"./22/ton.png": 77420,
	"./22/tp.png": 5961,
	"./22/twitter.png": 28266,
	"./car/TONwallet.png": 77234,
	"./car/ag.png": 97647,
	"./car/airdorp-item1-bg.png": 73137,
	"./car/airdorp-item2-bg.png": 79998,
	"./car/airdrop-logo.png": 69833,
	"./car/btn-copy.png": 45377,
	"./car/car-img.png": 42557,
	"./car/car_z.png": 53705,
	"./car/earn-key.png": 82605,
	"./car/facescan.png": 39348,
	"./car/finish.png": 84444,
	"./car/friend-logo.png": 40417,
	"./car/home-logo.png": 36275,
	"./car/icon-airdrop.png": 32236,
	"./car/icon-coin-sign.png": 15644,
	"./car/icon-coin.png": 45429,
	"./car/icon-frends.png": 23151,
	"./car/icon-home.png": 98236,
	"./car/icon-learderboard.png": 3624,
	"./car/icon-tasks.png": 79252,
	"./car/index-logo.png": 4609,
	"./car/it.png": 57689,
	"./car/page2_bg2.png": 77570,
	"./car/rank-1.png": 95446,
	"./car/rank-2.png": 83646,
	"./car/rank-3.png": 39252,
	"./car/ris-logo.png": 44585,
	"./car/sign-premium.png": 91723,
	"./car/sign.png": 48367,
	"./car/sign_top.png": 12675,
	"./car/tasks-logo.png": 61606,
	"./car/ton-icon-big.png": 37990,
	"./car/ton.png": 8237,
	"./car/tp.png": 67094,
	"./car/twitter.png": 41278,
	"./human/TONwallet.png": 14917,
	"./human/ag.png": 64821,
	"./human/airdorp-item1-bg.png": 37484,
	"./human/airdorp-item2-bg.png": 43283,
	"./human/airdrop-logo.png": 72571,
	"./human/btn-copy.png": 84596,
	"./human/earn-key.png": 63840,
	"./human/facescan.png": 45880,
	"./human/finish.png": 28027,
	"./human/friend-logo.png": 20590,
	"./human/home-logo.png": 99566,
	"./human/icon-airdrop.png": 11748,
	"./human/icon-coin-sign.png": 96296,
	"./human/icon-coin.png": 68356,
	"./human/icon-frends.png": 23303,
	"./human/icon-home.png": 78611,
	"./human/icon-learderboard.png": 28058,
	"./human/icon-tasks.png": 1549,
	"./human/index-face-scan.png": 70072,
	"./human/index-logo.png": 7699,
	"./human/it.png": 18025,
	"./human/loading.png": 57515,
	"./human/page2_bg2.png": 24612,
	"./human/rank-1.png": 9090,
	"./human/rank-2.png": 15877,
	"./human/rank-3.png": 69474,
	"./human/ris-logo.png": 55800,
	"./human/sign-premium.png": 8802,
	"./human/sign.png": 48485,
	"./human/sign_top.png": 44646,
	"./human/tasks-logo.png": 74457,
	"./human/ton-icon-big.png": 26885,
	"./human/ton.png": 50329,
	"./human/tp.png": 93605,
	"./human/twitter.png": 83865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31760;